module.exports = __webpack_public_path__ + "img/ibc-international-bio-cosmetics-conseil-experts-levres-seches.3a9f3558.jpg";